import styled from 'styled-components';

export const AvatarImage = styled.img`
  width: 40px;
  height: 40px;
  border-radius: 40px;
  margin-left: 15px;
  margin-right: 15px;
`;
